import request from '@/utilities/request'

// Report
export function getReports () {
  return request({
    url: '/reports',
    method: 'get'
  })
}

export function genReport (reqObj) {
    console.log(reqObj)
  return request({
    url: '/reports/generate',
    method: 'post',
    data: reqObj
  })
}

export function getReport (name) {
  return request({
    url: '/reports/' + name,
    method: 'get'
  })
}
